import { Restriction as StringRestriction } from "./Restriction";
export var String;
(function (String) {
    String.Restriction = StringRestriction;
})(String || (String = {}));
//# sourceMappingURL=index.js.map